import React, { useMemo, useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import Category2QueriesTab from './Category2QueriesTab';
import Category3QueriesTab from './Category3QueriesTab';
import { NlsAnalyticsTab, nlsAnalyticsTabs, nlsAnalyticsTabsList } from './nlsAnalyticsTabs';

const tabComponents: Record<NlsAnalyticsTab, React.ElementType> = {
  'category-2-queries': Category2QueriesTab,
  'category-3-queries': Category3QueriesTab,
};

export default function NlsAnalyticsPage() {
  const [activeTab, setActiveTab] = useState<NlsAnalyticsTab>('category-2-queries');
  const ActiveTabComponent = useMemo(() => tabComponents[activeTab], [activeTab]);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(_event, nextTab: NlsAnalyticsTab) => setActiveTab(nextTab)}
          variant="scrollable"
        >
          {nlsAnalyticsTabsList.map((tabKey) => (
            <Tab key={tabKey} value={tabKey} label={nlsAnalyticsTabs[tabKey].title} />
          ))}
        </Tabs>
      </Box>

      <ActiveTabComponent />
    </Box>
  );
}
